var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [
        _c(
          "span",
          { staticStyle: { "font-size": "18px", "font-weight": "600" } },
          [_vm._v("🎵 词汇音频管理")]
        ),
        _c(
          "div",
          { staticStyle: { float: "right" } },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small", icon: "el-icon-refresh" },
                on: { click: _vm.loadData }
              },
              [_vm._v("刷新")]
            )
          ],
          1
        )
      ]),
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "15px" }, attrs: { gutter: 15 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-num" }, [
                    _vm._v(_vm._s(_vm.stats.total))
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("总词汇数")])
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-num",
                      staticStyle: { color: "#67C23A" }
                    },
                    [_vm._v(_vm._s(_vm.stats.uploaded))]
                  ),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("已上传")])
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-num",
                      staticStyle: { color: "#E6A23C" }
                    },
                    [_vm._v(_vm._s(_vm.stats.pending))]
                  ),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("待上传")])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticStyle: { "margin-bottom": "15px" },
          attrs: { shadow: "never" }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "所属单元", clearable: "" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.unit,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "unit", $$v)
                        },
                        expression: "query.unit"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Unit 1", value: "U1" }
                      }),
                      _c("el-option", {
                        attrs: { label: "Unit 2", value: "U2" }
                      }),
                      _c("el-option", {
                        attrs: { label: "Unit 3", value: "U3" }
                      }),
                      _c("el-option", {
                        attrs: { label: "Unit 4", value: "U4" }
                      }),
                      _c("el-option", {
                        attrs: { label: "Unit 5", value: "U5" }
                      }),
                      _c("el-option", {
                        attrs: { label: "Unit 6", value: "U6" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "上传状态", clearable: "" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.status,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "已上传", value: "success" }
                      }),
                      _c("el-option", {
                        attrs: { label: "待上传", value: "pending" }
                      }),
                      _c("el-option", {
                        attrs: { label: "失败", value: "failed" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索单词", clearable: "" },
                    on: { clear: _vm.handleSearch },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      }
                    },
                    model: {
                      value: _vm.query.keyword,
                      callback: function($$v) {
                        _vm.$set(_vm.query, "keyword", $$v)
                      },
                      expression: "query.keyword"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: { data: _vm.tableData, border: "", stripe: "" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "word", label: "单词", width: "150" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "pronunciation",
                  label: "发音",
                  width: "200",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.statusTagType(scope.row.status),
                              size: "small"
                            }
                          },
                          [_vm._v(_vm._s(_vm.statusLabel(scope.row.status)))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "audioUrl",
                  label: "音频链接",
                  "min-width": "250",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.audioUrl
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  color: "#409EFF"
                                }
                              },
                              [_vm._v(_vm._s(scope.row.audioUrl))]
                            )
                          : _c("span", { staticStyle: { color: "#C0C4CC" } }, [
                              _vm._v("-")
                            ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "260" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-upload",
                          {
                            staticStyle: {
                              display: "inline-block",
                              "margin-right": "8px"
                            },
                            attrs: {
                              action: "",
                              "show-file-list": false,
                              "before-upload": function(file) {
                                return _vm.handleUploadOne(scope.row, file)
                              },
                              accept: ".mp3,.wav,.m4a,.ogg"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  size: "small",
                                  icon: "el-icon-upload2"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.status === "success"
                                        ? "重新上传"
                                        : "上传"
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        scope.row.audioUrl
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "4px" },
                                attrs: {
                                  type: "text",
                                  size: "small",
                                  icon: "el-icon-video-play"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handlePreview(scope.row)
                                  }
                                }
                              },
                              [_vm._v("试听")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "15px", "text-align": "right" },
            attrs: {
              background: "",
              "current-page": _vm.pagination.current,
              "page-size": _vm.pagination.size,
              total: _vm.pagination.total,
              "page-sizes": [20, 50, 100],
              layout: "total, sizes, prev, pager, next"
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "音频预览",
            visible: _vm.previewVisible,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.previewVisible = $event
            }
          }
        },
        [
          _c("div", { staticStyle: { "text-align": "center" } }, [
            _c(
              "div",
              { staticStyle: { "font-size": "36px", "margin-bottom": "10px" } },
              [_vm._v("🔊 " + _vm._s(_vm.previewWord))]
            ),
            _c(
              "div",
              { staticStyle: { color: "#909399", "margin-bottom": "15px" } },
              [_vm._v(_vm._s(_vm.previewPronunciation))]
            ),
            _vm.previewUrl
              ? _c("audio", {
                  staticStyle: { width: "100%" },
                  attrs: { src: _vm.previewUrl, controls: "" }
                })
              : _c("div", { staticStyle: { color: "#C0C4CC" } }, [
                  _vm._v("暂无音频")
                ])
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }